import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import GameCanvas from "./components/GameCanvas/GameCanvas";
import Button from "./components/Button/Button";
import RemainingLivesDisplay from "./components/RemainingLivesDisplay/RemainingLivesDisplay";
import ScoreUpdateDisplay from "./components/ScoreUpdateDisplay/ScoreUpdateDisplay";
import "./App.css";

const App = () => {
  const isGameStarted = useSelector((state) => state.game.isGameStarted);
  const isGameOver = useSelector((state) => state.game.gameOver);

  const [isSmallDevice, setIsSmallDevice] = useState(false);

  // Detect mobile + tablet (always keep this updated)
  useEffect(() => {
    const checkDevice = () => setIsSmallDevice( window.innerWidth <= 1024 || window.innerHeight <= 800);

    checkDevice(); // run once on mount
    window.addEventListener("resize", checkDevice);
    return () => window.removeEventListener("resize", checkDevice);
  }, []);

  const isPlaying = isGameStarted && !isGameOver;

  // ✅ Only block when NOT playing
  const shouldBlock = useMemo(() => isSmallDevice && !isPlaying, [isSmallDevice, isPlaying]);

  // Lock scroll only when overlay is showing
  useEffect(() => {
    if (!shouldBlock) return;

    const html = document.documentElement;
    const body = document.body;

    const originalHtmlOverflow = html.style.overflow;
    const originalBodyOverflow = body.style.overflow;

    html.style.overflow = "hidden";
    body.style.overflow = "hidden";

    return () => {
      html.style.overflow = originalHtmlOverflow;
      body.style.overflow = originalBodyOverflow;
    };
  }, [shouldBlock]);

  return (
    <>
      {/* 🚫 Mobile / Tablet Block (only when NOT playing) */}
      {shouldBlock && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,1)",
            zIndex: 9999,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            color: "white",
            textAlign: "center",
            padding: "20px",
          }}
        >
          <h1 style={{ fontSize: "2.3rem", marginBottom: "20px" }}>
            ⚙️ Desktop Only
          </h1>

          <p style={{ fontSize: "1.1rem", maxWidth: "520px" }}>
            This game is designed only for desktop and laptop{" "}
            devices with screens <b>greater than 1024 * 800</b>. Please switch to a larger screen to play.
          </p>
        </div>
      )}

      {/* 🎮 Game UI */}
      <div className="container">
        <div className="button-wrapper">
          {!isGameStarted && <Button type="start" />}
        </div>

        <div className="button-lives-wrapper">
          <ScoreUpdateDisplay />
          {isGameStarted && !isGameOver ? (
            <Button type="pause" />
          ) : isGameOver ? (
            <Button type="replay" />
          ) : null}
          <RemainingLivesDisplay />
        </div>

        <GameCanvas height={800} width={600} />
      </div>
    </>
  );
};

export default App;


